module.exports = __webpack_public_path__ + "e907ea1ad1b79384888e0d51ac73d013.svg";